import { Reveal } from "./motion";
import { PROBLEM } from "../../lib/siteData";

export const Problem = () => {
  return (
    <section id="problem" data-testid="problem-section" className="relative bg-ink py-28 md:py-40">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12 md:gap-16">
          <Reveal className="md:col-span-7">
            <span className="font-body text-xs font-bold uppercase tracking-[0.25em] text-brand">{PROBLEM.overline}</span>
            <h2 className="mt-6 font-heading text-4xl sm:text-5xl lg:text-6xl font-bold uppercase leading-[0.95] tracking-tighter">
              {PROBLEM.title}
            </h2>
          </Reveal>
          <Reveal delay={0.1} className="md:col-span-5 md:pt-16">
            <p className="font-body text-lg font-light leading-relaxed text-neutral-400">{PROBLEM.body}</p>
            <p className="mt-6 font-heading text-xl md:text-2xl font-medium uppercase tracking-tight text-white">
              {PROBLEM.punch}
            </p>
          </Reveal>
        </div>

        <div className="mt-20 grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/10 sm:grid-cols-3">
          {PROBLEM.stats.map((s, i) => (
            <Reveal key={s.k} delay={i * 0.08} className="bg-ink p-8 md:p-10">
              <div className="font-heading text-sm font-medium uppercase tracking-[0.2em] text-brand">{s.k}</div>
              <div className="mt-3 font-heading text-2xl md:text-3xl font-medium uppercase tracking-tight text-white">{s.v}</div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
